/*
  Microsite copy for Speed Gates, Track Days and Corporate Events.
  Written to memory/VOICE.md (client, 2026-09-11): confident, understated,
  specific. State what the format is; never promise how a day will run.
  Marshals are provided by the circuit. Nobody at Grid Masters competes.
  Photography: client Sets 1-5 (assets_raw/cut_set5.py); HD hero cuts: assets_raw/cut_ms_hd.py.
*/
import { MS_HD, PHONE_HD, NATIVE } from "./hdSlides";

export const MICROSITES = {
  "speed-gates": {
    slug: "speed-gates",
    name: "Speed Gates",
    logo: { src: "/brand/logos/GM-Speed-Gates-white.webp", alt: "Grid Masters Speed Gates", width: 640, height: 640 },
    status: "Launching 2026",
    tagline: "Autocross for the drivers coming up",
    // HD (client, 2026-10-11): same frames, cut from the originals at 1920/2560/3840 (assets_raw/cut_ms_hd.py).
    slides: [MS_HD("ms-sg-1-911-pan"), MS_HD("ms-sg-2-evo-32"), MS_HD("ms-sg-3-supra-esses")],
    // Phones (client, 2026-09-17): whole cars in 9:16 - assets_raw/cut_ms_mobile.py; HD cut 2026-10-11.
    phoneSlides: [PHONE_HD("ms-sg-911-04"), PHONE_HD("ms-sg-supra-esses"), PHONE_HD("hero-pitlane-above")],
    marquee: ["SPEED GATES", "AUTOCROSS", "ONE CAR AT A TIME", "AGAINST THE CLOCK", "LAUNCHING 2026"],
    intro: {
      heading: "A gated course. One car at a time. The clock decides",
      body: [
        "Speed Gates is the Grid Masters autocross platform. A course of cones and timing gates is set out on a closed paddock or runway, and you drive it alone against the clock. No other cars on course, no top speeds. Car control and precision decide the result.",
      ],
    },
    numbers: [
      { n: "1", label: "car on course at a time" },
      { n: "3", label: "timed runs, best one counts" },
      { n: "0", label: "overtaking" },
    ],
    format: {
      heading: "How a Speed Gates run works",
      items: [
        { t: "Sign-on", d: "Documents and a look over the car before you go out." },
        { t: "Course walk", d: "Walk the gates and learn the sequence before the first run." },
        { t: "Timed runs", d: "Three runs against the clock. Best one counts. Cones touched add time; a missed gate is a wipe." },
        { t: "Results", d: "Classified by class and overall after the last run." },
      ],
    },
    // Client, 2026-10-07: the "Built for the driver, not the spec sheet" block is
    // off for Speed Gates. null = section not rendered (EventMicrosite.jsx).
    who: null,
    gallery: ["/photos/gal-gt3rs-green.webp", "/photos/gal-cayman-garage.webp", "/photos/gal-trophies.webp", "/photos/gal-sunset-paddock.webp"],
    register: {
      heading: "Be there for the first one",
      body: "Leave your details and we will tell you when dates, venue and entry fees are confirmed. No commitment.",
    },
  },

  "track-days": {
    slug: "track-days",
    name: "Track Days",
    status: "Launching 2026",
    tagline: "Your car. Our circuit. Open pit lane",
    // Yas Marina night frames first (client, 2026-09-17): purple 765LT side shot, blue M4 rounding the corner; 3rd unchanged.
    // HD (client, 2026-10-11): same framing, cut from the originals (cut_ms_hd.py). Sunset paddock caps at its native 2848.
    slides: [MS_HD("hero-ul-7-yas-765lt-39"), MS_HD("hero-td-yas-m4"), MS_HD("ms-td-3-sunset-paddock", [1920, 2560, 2848])],
    phoneSlides: [PHONE_HD("ms-td-m4"), PHONE_HD("ms-td-gt3rs-wing"), PHONE_HD("ms-td-sunset-paddock", [1080, 1602])],
    marquee: ["TRACK DAYS", "OPEN PIT LANE", "YAS MARINA", "DUBAI AUTODROME", "LAUNCHING 2026"],
    intro: {
      heading: "Open pit lane on the circuits we race at",
      body: [
        "Grid Masters Track Days are open-pit-lane days at Yas Marina and Dubai Autodrome. No grids, no timing pressure. Drive when you want and come in when you want, with the circuit's marshals, medical and recovery on site for the day.",
        "Timing is there for those who want it and instruction for those who ask. The paddock is run by the same team that runs Ultimate Lap.",
      ],
    },
    numbers: [
      { n: "2", label: "circuits: Yas Marina and Dubai Autodrome" },
      { n: "1:1", label: "instruction available on request" },
      { n: "0", label: "grids, sessions or timing pressure" },
    ],
    format: {
      heading: "How a Track Day works",
      items: [
        { t: "Sign-on", d: "Documents, noise test and a look over the car." },
        { t: "Briefing", d: "Flags, pit-lane rules and overtaking etiquette for the day." },
        { t: "Open pit lane", d: "Drive as much or as little as you like. Optional transponder timing and one-to-one instruction." },
      ],
    },
    // Client, 2026-10-07: the "first laps to fast laps" block is off for Track Days.
    who: null,
    gallery: ["/photos/gal-yas-m4.webp", "/photos/gal-garage-wide.webp", "/photos/gal-911-04.webp", "/photos/gal-garage-crowd.webp"],
    register: {
      heading: "Hear about dates first",
      body: "Leave your details and we will tell you when circuits, dates and prices are confirmed.",
    },
  },

  "corporate-events": {
    slug: "corporate-events",
    name: "Corporate Events",
    status: "By arrangement",
    tagline: "Motorsport as hospitality",
    // Client (2026-10-07): DSC01086 - the Dubai Autodrome group under the 20-years gantry - leads.
    // Then the night grid, Yas Marina group under the gantry, drivers talking (client order, 2026-09-17).
    // Client (2026-10-11): slides 2 and 3 are the EXACT landing-hero files (GT3 RS grid
    // under the Autodrome gantry = gmsite-2, Yas group = gmsite-3), shipped untouched like
    // the landing; slides 1 and 4 keep their framing and are re-cut HD (cut_ms_hd.py).
    slides: [
      MS_HD("ms-ce-4-dubai-group-gantry", [1920, 2560, 3840], "50% 55%"),
      NATIVE("/photos/hero/hero-gm-9-autodrome-grid-2000.webp", "50% 50%"),
      NATIVE("/photos/hero/hero-gm-12-yas-group-client.webp", "50% 50%"),
      MS_HD("ms-ce-1-drivers-talking"),
    ],
    // V1 phone hero (client, 2026-09-19): 0:07-0:37 (30s) of the April '26
    // ceremony reel (gm-april26-reel-ceremony), 720x1280, looped.
    phoneFilm: { src: "/video/hero/corp-hero-phone-ceremony.mp4", poster: "/video/hero/corp-hero-phone-ceremony.jpg" },
    phoneSlides: ["/photos/mobile/ms-ce-dubai-group-gantry.webp", "/photos/mobile/hero-yas-group.webp", "/photos/mobile/ms-ce-drivers-talking.webp"],
    marquee: ["CORPORATE EVENTS", "PRIVATE CIRCUIT HIRE", "HOT LAPS", "HOSPITALITY", "BRAND ACTIVATION"],
    intro: {
      heading: "A circuit, your people, one day built around your brief",
      body: [
        "Grid Masters builds private motorsport days for companies and brands: circuit hire, driving experiences, passenger hot laps, trackside hospitality and content. The same team that builds our championships builds your day.",
        "From a leadership offsite for twenty to a product launch for three hundred, every programme starts with your objectives and one point of contact.",
      ],
    },
    numbers: [
      { n: "300", label: "guests, one programme" },
      { n: "1", label: "point of contact, brief to debrief" },
      { n: "2", label: "circuits available for private hire" },
    ],
    format: {
      heading: "What we build",
      items: [
        { t: "Circuit hire", d: "Yas Marina or Dubai Autodrome, closed to the public for your day." },
        { t: "Driving", d: "Instructed laps in your guests' cars or ours, timed team challenges and passenger hot laps." },
        { t: "Hospitality", d: "Trackside suites, catering and paddock access. We run the day; you host it." },
        { t: "Brand and content", d: "Livery, signage, photography and film. Your brand on the circuit and in the edit afterwards." },
      ],
    },
    // Client, 2026-10-07: the "teams, clients and launches" block is off for Corporate Events.
    who: null,
    gallery: ["/photos/gal-garage-talk.webp", "/photos/people-6-yas-group-gantry.webp", "/photos/gal-banner.webp", "/photos/people-7-yas-briefing.webp"],
    register: {
      heading: "Tell us about your event",
      body: "A few details and we will come back with ideas, availability and a first proposal.",
    },
  },
};

export const MICROSITE_SLUGS = Object.keys(MICROSITES);
